import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import {
  ListDisplay,
  ContentDisplay,
  BaseText,
  ProgressStep
} from '@warrenbrasil/nebraska-web';
import { IOrderReceipt } from '@/modules/wealth/services/wealth-orders/types';
import { IStep } from '../../types';


export default /*#__PURE__*/_defineComponent({
  __name: 'WithdrawSteps',
  props: {
    orderData: null,
    progress: null
  },
  setup(__props: any) {

const props = __props as {
  orderData: IOrderReceipt;
  progress: IStep[];
}



const isCanceled = computed(() => {
  return props.orderData?.status?.label === 'Cancelado';
});

const amountLabel = computed(() => {
  const values = ['Cotizado', 'Concluído'];
  return values.includes(props.orderData?.status?.label)
    ? 'Bruto'
    : 'Solicitado';
});

const netValueLabel = computed(() => {
  return props.orderData?.status?.label === 'Processando'
    ? 'Valor líquido aproximado'
    : 'Valor líquido';
});

const footerType = computed(() => {
  return isCanceled.value ? 'caption' : 'button';
});

const footerLabel = computed(() => {
  return isCanceled.value ? props.orderData.description : 'Detalhes do Produto';
});

return { __sfc: true,props, isCanceled, amountLabel, netValueLabel, footerType, footerLabel, ListDisplay, ContentDisplay, BaseText, ProgressStep }
}

})